import { BuyGuideVendorDocumentList } from '../../../components/BuyGuide';

export function BuyGuideRebateProgramDocuments() {
  return <BuyGuideVendorDocumentList />;
}
